// src/utils/cropImage.js
function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", reject);
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });
}

export async function getCroppedBlob(imageSrc, cropPixels, opts = {}) {
  const mimeType = opts.mimeType || "image/jpeg";
  const quality = typeof opts.quality === "number" ? opts.quality : 0.92;

  const image = await createImage(imageSrc);

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Could not get canvas context");

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = Math.round(cropPixels.width * scaleX);
  canvas.height = Math.round(cropPixels.height * scaleY);

  const cropX = cropPixels.x * scaleX;
  const cropY = cropPixels.y * scaleY;
  const cropWidth = cropPixels.width * scaleX;
  const cropHeight = cropPixels.height * scaleY;
  const sourceX = Math.max(0, cropX);
  const sourceY = Math.max(0, cropY);
  const sourceWidth = Math.max(0, Math.min(image.naturalWidth - sourceX, cropWidth - Math.max(0, -cropX)));
  const sourceHeight = Math.max(0, Math.min(image.naturalHeight - sourceY, cropHeight - Math.max(0, -cropY)));
  const destinationX = Math.max(0, -cropX);
  const destinationY = Math.max(0, -cropY);

  if (sourceWidth > 0 && sourceHeight > 0) {
    ctx.drawImage(
      image,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      destinationX,
      destinationY,
      sourceWidth,
      sourceHeight
    );
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("Canvas was empty"))),
      mimeType,
      quality
    );
  });
}
